import styles from "./SettingsTags.module.scss";
import useSettingsTags from "./useSettingsTags";
import React from "react";
import {MODE_CREATE, MODE_EDIT} from "../../../../codes";
import Card from "../../../../common/Card";
import CardEmpty from "../../../../common/CardEmpty";
import clsx from "clsx";
import {TagEditor} from "../editor/TagEditor";
import useProject from "../../../../util/useProject";
import {FabButton} from "../../../../common/FabButton";
import {Content, ContentFixed} from "../../../../common/Content";
import {SettingsMenuMobile} from "../../Settings";
import {SettingsContent} from "../../SettingsContent";
import {SettingsTopMenu} from "../../SettingsTopMenu";

const SettingsTags = () => {
  const {runWithExpiration} = useProject();
  const {t, tags, showTagEditor} = useSettingsTags();

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_tags"/>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent withFab={true}>
        <FabButton onClick={runWithExpiration(() => showTagEditor(MODE_CREATE, {}))}/>

        <Card ifCond={!tags.length}>
          <CardEmpty>{t("no_tags")}</CardEmpty>
        </Card>

        <Card ifCond={tags.length}>
          {tags.map(tag => {
            const [background, color] = tag.color.split("|");

            return <div className={clsx(styles.tag)} key={tag.id}>
              <div className={clsx(styles.tagDetails, "hover-selectable")}
                   onClick={runWithExpiration(() => showTagEditor(MODE_EDIT, tag))}>
                <div className={styles.tagName}>
                  <span className={clsx(styles.tagValue)} style={{background, color}}>
                    <span className={clsx(styles.tagIcon, "material-icons")} style={{color}}>label</span>

                    {tag.name}
                  </span>
                </div>
                <div className={styles.tagDescription}>{tag.description}</div>
              </div>
            </div>;
          })}
        </Card>
      </SettingsContent>

      <TagEditor/>
    </Content>
  );
};

export default SettingsTags;
